<template>
  <div>
    <div id="footer" class="container-fluid hidden-xs">
      <div class="bottominfo">
        <span class="infoforper20 hidden-ipd">
          <p class="title">核心产品</p>
          <p class="address_tel_fax">固定翼/多旋翼航测无人机</p>
          <p class="address_tel_fax">创念云管理平台</p>
          <p class="address_tel_fax">跟随车/智能搬运车</p>
          <p class="address_tel_fax">激光雷达</p>
        </span>
        <span class="infoforper20 hidden-ipd">
          <p class="title">技术服务</p>
          <p class="address_tel_fax">软件定制服务</p>
          <p class="address_tel_fax">航测服务</p>
          <p class="address_tel_fax">三维扫描服务</p>
          <p class="address_tel_fax">模型制作服务</p>
        </span>
        <span class="infoforper20">
          <p class="title">联系我们</p>
          <p class="address_tel_fax">李经理 17628127917 （四川）</p>
          <p class="address_tel_fax">邓经理 18188398308 （重庆）</p>
          <p class="address_tel_fax">魏经理 15217577896 （新疆）</p>
          <p class="address_tel_fax">周经理 13759595500 （云南）</p>
          <p class="address_tel_fax">地址：四川省.南充.高新孵化园</p>
        </span>
        <span class="infoforper40">
          <div class="infoforper33">
            <p class="address_tel_fax">qq群：</p>
            <img class="ewmpng" src="@/assets/img/qqewm.png" />
          </div>
          <div class="infoforper33">
            <p class="address_tel_fax">微信公众号：</p>
            <img class="ewmpng" src="@/assets/img/gzhewm.png" />
          </div>
          <div class="infoforper33">
            <p class="address_tel_fax">淘宝店铺：</p>
            <img class="ewmpng" src="@/assets/img/tbewm.png" />
          </div>
        </span>
      </div>
      <p class="copy">
        <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">©2021&nbsp;&nbsp;&nbsp;&nbsp;南充创念三维科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;蜀ICP备2021011867号-1</a>
      </p>
    </div>
    <!-- 移动端 -->
    <div class="footer-mobile visible-xs">
      <div class="backToTop" @click="toTop">回到顶部<i class="el-icon-arrow-up"></i></div>
      <div class="collspan-item">联系我们</div>
      <div class="collspan-item">李经理 17628127917 （四川）</div>
      <div class="collspan-item">邓经理 18188398308 （重庆）</div>
      <div class="collspan-item">魏经理 15217577896 （新疆）</div>
      <div class="collspan-item">周经理 13759595500 （云南）</div>
      <div class="collspan-item">地址：四川省.南充.高新孵化园</div>
      <div class="more">
        <div>©2021&nbsp;&nbsp;南充创念三维科技有限公司</div>
        <div>
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery">蜀ICP备2021011867号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    toTop() {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}

.bottominfo {
  width: 100%;
  margin-top: 10px;
  height: 230px;
}

.infoforper20 {
  width: 20%;
  float: left;
  overflow-x: visible;
  white-space: nowrap;
}

.infoforper40 {
  width: 40%;
  float: left;
  margin-top: 20px;
}

.infoforper33 {
  width: 33%;
  float: left;
}

.ewmpng {
  float: right;
  margin: 10px;
}

.logo {
  width: 95px;
  height: 30px;
  margin: 10px auto 20px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  white-space: nowrap;
}

.address_tel_fax.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 30px 0 60px 0;
}

.copy a {
  color: #d3d3d3;
}

.footer-mobile {
  color: #ebeff2;
  background: #474747;
}

.footer-mobile .backToTop {
  height: 50px;
  line-height: 50px;
  color: #888;
  text-align: center;
  border-bottom: 1px solid #555;
}

.footer-mobile .collspan-item {
  line-height: 22px;
  padding: 15px 5px;
  border-bottom: 1px solid #555;
  margin: 0 15px;
}

.footer-mobile .more {
  padding: 10px 15px 40px 15px;
  color: #606664;
}

.footer-mobile .more a {
  color: #606664;
}

@media screen and (min-width: 760px) and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }

  .hidden-ipd {
    display: none;
  }

  .infoforper20 {
    width: 40%;
  }

  .infoforper40 {
    width: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue